import request from '@/service/api'
import ConfigType from '@/service/api/type'
import qs from 'qs'
enum DocumentsApi {
    // 单据管理-手工入库
    MANUALINVENTORY_PAGE = '/ManualOrderIssue/Page',//主列表
    MANUALINVENTORY_DELETE = '/WareManualOrders/delete',//删除
    MANUALINVENTORY_ADD_WARECONTAINERSELECTLIST = '/WareContainer/conatinerList',//新增入库单容器列表数据
    MANUALINVENTORY_ADD_RANDOMENTRYNO = '/GoodsDelivery/generateSystemNo',//新增获取系统生成入库单号
    MANUALINVENTORY_ADD_MATERIALLIST = '/WareMaterial/page',//物料表数据
    MANUALINVENTORY_CREATEORDER = '/WareManualOrders/add',//创建入库单任务
    MANUALINVENTORY_EDIT_PAGE = '/WareManualOrders/detailPage',//打开编辑的获取之前新增的物料
    MANUALINVENTORY_EDIT = '/WareManualOrders/edit',//编辑确定
    MANUALINVENTORY_INWAREHOUSE = '/WareManualOrders/inWareHouse',//入库按钮
    // 单据管理-手工出库
    MANUALINVENTORY_OUTPAGE = '/ManualOrderIssue/Page',//主列表
    MANUALINVENTORY_STOCK = '/ManualOrderIssue/StockPage',//出库单对应库存信息
    MANUALINVENTORY_DETAIL = '/ManualOrderIssue/DetailPage',//出库单对应编辑库存信息
    MANUALINVENTORY_ISSUED = '/ManualOrderIssue/Issued',//出库单下发
    MANUALINVENTORY_ADD = '/ManualOrderIssue/Add',//新增手动单出库
    MANUALINVENTORY_EDITISSUE = '/ManualOrderIssue/Edit',//编辑手动单出库
    MANUALINVENTORY_OUTDELETE = '/ManualOrderIssue/Delete',//出库单删除
    MANUALINVENTORY_ISSUED_ERRAY = '/ManualOrderIssue/NewSingleTransferIssue',//出库单详情下发
    MANUALINVENTORY_ISSUED_BATCH = '/ManualOrderIssue/NewBatchTransferIssue',//出库单下发批量
    MANUALINVENTORY_ORDER = '/ManualOrderIssue/order',//定时获取单据
    DOCUMENTISSUEPRINTING = 'ManualOrderIssue/PrintWareOrder',//单据出库打印
    SIMPLEPRINTING = '/ManualOrderIssue/Order',//分拣单打印
    ShipmentComplete = '/ManualOrderIssue/OrdercComplete',//分拣单打印
    
    // 单据管理-手工出库-调拨单
    STOCK_TRANSFER = '/ManualOrderIssue/DistributionLocation',//分配库位
    STOCK_TRANSFER_SURE = '/ManualOrderIssue/DistributionConfirm',//分配库位确认
    STOCK_TRANSFER_BUTTON = '/ManualOrderIssue/order',//调拨单按钮
    STOCK_TRANSFER_DETIAL = '/ManualOrderIssue/orderdetails',//调拨单明细
    STOCK_TRANSFER_ONE_KEY = 'ManualOrderIssue/OnekeyDistributionLocation',//一键推荐库位    

    MANUALINVENTORY_CREATEOUTWAREHOUSE = '/WareManualOrders/outAdd',//创建出库单
    MANUALINVENTORY_OUTDETAILSPAGE = '/WareManualOrders/detailPage',//出库单详情
    
    MANUALINVENTORY_OUTWAREHOUSE = '/WareManualOrders/outWareHouse',//出库按钮
    MANUALINVENTORY_JILIGULU = '/WareStock/outPage',
    //单据管理 - 分拣管理
    SORTINGMANAGEMENT_PAGE = '/WareSortOrder/page',
    MANDATORYSORTING = '/WareSortOrder/SortOrderFinish',
    SORTINGMANAGEMENT_DEL = '/WareSortOrder/Delete',//分拣删除
}
// 单据管理-手工入库-手工入库列表
export const getManualInventoryPage = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.MANUALINVENTORY_PAGE}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 单据管理-手工入库-删除
export const deleteManualInventoryPage = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.MANUALINVENTORY_DELETE,
        method: 'post',
        data: data
    })
}
// 单据管理-手工入库 - 编辑
export const editManualInventoryPage = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.MANUALINVENTORY_EDIT_PAGE}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 单据管理-手工入库-新增入库单获取容器列表
export const getWareContainerData = (): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.MANUALINVENTORY_ADD_WARECONTAINERSELECTLIST}`,
        method: 'get'
    })
}
// 单据管理-手工入库-新增入库单生成入库单号
export const getRandomEntryNo = (): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.MANUALINVENTORY_ADD_RANDOMENTRYNO}`,
        method: 'get'
    })
}
// 单据管理-手工入库-新增物料窗口中的物料表
export const getManualInventoryMaterialData = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.MANUALINVENTORY_ADD_MATERIALLIST}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 单据管理-手工入库-入库单据创建
export const createWareManuaOrder = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.MANUALINVENTORY_CREATEORDER,
        method: 'post',
        data: data
    })
}
// 单据管理-手工入库-入库单据编辑
export const editWareManuaOrder = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.MANUALINVENTORY_EDIT,
        method: 'post',
        data: data
    })
}
// 单据管理 - 手工入库 - 入库按钮
export const inWareHouse = (data: any): ConfigType<any> => {
    // console.log(qs.stringify(data))
    return request({
        url: DocumentsApi.MANUALINVENTORY_INWAREHOUSE,
        method: 'post',
        data: data
    })
}
// ====================================================================================//

// 单据管理-手工入库-手工出库列表

export const ordertime = (): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.MANUALINVENTORY_ORDER}`,
        method: 'get'
    })
}
// 单据管理-手工入库-手工出库列表
export const getManualOutventoryPage = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.MANUALINVENTORY_OUTPAGE}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 单据管理-手工入库-创建手动单对应库存信息
export const getManualOutstock = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.MANUALINVENTORY_STOCK}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 单据管理-手工入库-编辑接口
export const getManualOutedit = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.MANUALINVENTORY_DETAIL}?${qs.stringify(data)}`,
        method: 'get'
    })
}

// 单据管理-打印-单据出库
export const documentIssuePrinting = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.DOCUMENTISSUEPRINTING}?${qs.stringify(data)}`,
        method: 'get'
    })
}

// 单据管理-手工出库-分拣单打印
export const simplePrinting = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.SIMPLEPRINTING}?${qs.stringify(data)}`,
        method: 'get'
    })
}


// 单据管理-手工出库-分拣单打印
export const simplePrintingX = (data: any): ConfigType<any> => {
    return request({
        url: '/ManualOrderIssue/PrintWareSortOrder',
        method: 'get',
		params:data
    })
}
export const shipmentComplete = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.ShipmentComplete,
        method: 'post',
        data:data
    })
}
// 单据管理-手工入库-编辑接口
export const getManualOutissed = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.MANUALINVENTORY_ISSUED,
        method: 'post',
        data: data
    })
}
// 单据管理-手工入库-编辑接口
export const getissed = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.MANUALINVENTORY_ISSUED_ERRAY,
        method: 'post',
        data: data
    })
}
// 单据管理-手工入库-编辑接口
export const getbatch = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.MANUALINVENTORY_ISSUED_BATCH,
        method: 'post',
        data: data
    })
}

// 单据管理 - 手工出入库 - 手工出库新增出库单
export const outWareManuaOrder = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.MANUALINVENTORY_CREATEOUTWAREHOUSE,
        method: 'post',
        data: data
    })
}
// 单据管理 - 手工出入库 - 新增出库单
export const addWareManuaOrder = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.MANUALINVENTORY_ADD,
        method: 'post',
        data: data
    })
}
// 单据管理 - 手工出入库 - 新增出库单
export const editManuaOrder = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.MANUALINVENTORY_EDITISSUE,
        method: 'post',
        data: data
    })
}

//单据管理 - 手工出入库 - 手工出库详情
export const getOutDetailsPage = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.MANUALINVENTORY_OUTDETAILSPAGE}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 单据管理-手工入库-删除
export const deleteOutDataPage = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.MANUALINVENTORY_OUTDELETE,
        method: 'post',
        data: data
    })
}
// 单据管理-手工入库-入库按钮
export const outWareHouse = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.MANUALINVENTORY_OUTWAREHOUSE,
        method: 'post',
        data: data
    })
}
//单据管理 - 手工出入库 - 新增出库按钮弹出的列表
export const getOutJiLiGuLu = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.MANUALINVENTORY_JILIGULU}?${qs.stringify(data)}`,
        method: 'get'
    })
}
//================================================================================//
//调拨单出库
export const stocktransfer = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.STOCK_TRANSFER}?${qs.stringify(data)}`,
        method: 'get'
    })
}

// 单据管理-手工入库-一键推荐库位
export const stockonekey = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.STOCK_TRANSFER_ONE_KEY,
        method: 'post',
        data: data
    })
}
// 单据管理-手工入库-编辑接口
export const stocktransferdeta = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.STOCK_TRANSFER_SURE,
        method: 'post',
        data: data
    })
}
//调拨单出库
export const stocktransferbott = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.STOCK_TRANSFER_BUTTON}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 单据管理-手工入库-编辑接口
export const stocktransfersure = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.STOCK_TRANSFER_DETIAL,
        method: 'post',
        data: data
    })
}
// ====================================================================================//
// 单据管理-分拣管理列表数据

export const getSortingManagementPage = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.SORTINGMANAGEMENT_PAGE}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 单据管理-强制分拣
export const getMandatorySorting = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.MANDATORYSORTING,
        method: 'post',
        data: data
    })
}
// 单据管理-手工入库-删除
export const delsortDataPage = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.SORTINGMANAGEMENT_DEL,
        method: 'post',
        data: data
    })
}
